import * as React from "react";
import {connect} from "react-redux";
import {bindActionCreators, Dispatch} from "redux";

import {setFavouriteCar} from "../../../app/actions/load_local_storage_favourites_to_store";
import {IStore} from "../../../app/reducers/hybrid_reducer";
import {RequestState} from "../../../app/utils/request_response_utils/factories/reduce_request_state";
import {ViewType} from "../../../tracking/view_type/view_type";
import {ICarDetailResponse} from "../actions/fetch_cars_details_at_route";
import {CarsDetailForSale} from "./car_details/CarsDetailForSale";

interface IStateProps {
    car: {
        detail: ICarDetailResponse;
        // carGallleryAWS: string[] | [];
        requestState: RequestState;
    };
    viewType: ViewType | null;
    favouriteCars: number[];
}

interface IActionProps {
    setFavouriteCar: typeof setFavouriteCar;
}

interface IProps extends IStateProps, IActionProps {}

const CarDetailsDynamicC = (props: IProps) => {
    const {car, viewType} = props;
    // const activeOffer = props.offer.detail.is_active;
    return (
        <>
            {/*{activeOffer ? (*/}
            {/*    <OfferDetailForSale offerFeatures={offerFeatures} offer={offer.detail} viewType={viewType} />*/}
            {/*) : (*/}
            {/*    <OfferDetailSold offer={offer.detail} />*/}
            {/*)}*/}
            <CarsDetailForSale car={car.detail.data} viewType={viewType} setFavouriteCar={props.setFavouriteCar} favouriteCars={props.favouriteCars} />

            {/*<NoPrint>*/}
            {/*    <Footer addBottomOffset />*/}
            {/*</NoPrint>*/}
        </>
    );
};

const mapStateToProps = (store: IStore): IStateProps => ({
    car: {
        detail: store.offer.car,
        //  carGallleryAWS: store.offer.carGallleryAWS.data.galleryAWS,
        requestState: store.offer.offerRequestState
    },
    viewType: store.viewType.current,
    favouriteCars: store.favourites.favourites
});

function mapActionsToProps(dispatch: Dispatch): IActionProps {
    return bindActionCreators({setFavouriteCar}, dispatch);
}

export const CarDetailsDynamic = connect(mapStateToProps, mapActionsToProps)(CarDetailsDynamicC);
